export default __webpack_public_path__ + "static/media/last-ned.3ceb0269.svg";